import axios from 'axios';

import { publicAxiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const listCustomerMetaData = () =>
  axios.get(
    `${getV2RootUrl()}/meta-data-config/customer`,
    publicAxiosHeaderV2()
  );
